export class User {
    constructor(name, id, avatar, level) {
        this.tablePosition = -1;
        this.game = undefined;
        this.name = name;
        this.id = id;
        if (!id)
            this.id = Math.floor(Math.random() * 1000000);
        this.avatar = avatar;
        this.level = level;
    }
    onMessage(eventName, ...args) {
        console.log(`User:${this.level}.onMessage:`, eventName, args);
    }
    ;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvdXNlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxNQUFNLE9BQU8sSUFBSTtJQU9iLFlBQVksSUFBWSxFQUFFLEVBQVUsRUFBRSxNQUFjLEVBQUUsS0FBWTtRQUYzRCxrQkFBYSxHQUFXLENBQUMsQ0FBQyxDQUFDO1FBQzNCLFNBQUksR0FBVSxTQUFTLENBQUM7UUFFM0IsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUM7UUFDakIsSUFBSSxDQUFDLEVBQUUsR0FBRyxFQUFFLENBQUM7UUFDYixJQUFHLENBQUMsRUFBRTtZQUFFLElBQUksQ0FBQyxFQUFFLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsTUFBTSxFQUFFLEdBQUcsT0FBTyxDQUFDLENBQUM7UUFDdEQsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7UUFDckIsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUM7SUFDdkIsQ0FBQztJQUNNLFNBQVMsQ0FBQyxTQUFpQixFQUFFLEdBQUcsSUFBVztRQUM5QyxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsSUFBSSxDQUFDLEtBQUssYUFBYSxFQUFFLFNBQVMsRUFBRSxJQUFJLENBQUMsQ0FBQztJQUNsRSxDQUFDO0lBQUEsQ0FBQztDQUNMIn0=